import { gsap } from 'gsap';

window.dAgency.initInputs = (rootEl = null) => {
  const attributes = {
    password: 'data-input-password',
  };

  const selectors = {
    animatedLabelsWrapper: '[data-input-animated-label]',
    textareaProxy: '.textarea__proxy',
    fancySelects: '[data-choices-select]',
    passwordInput: `[${attributes.password}]`,
    iconClass: '.input-icon',
    generalInputWrapper: '.input-container',
  };

  const activateInput = function (animationTarget, status) {
    const height = status ? 'auto' : 0;
    const padding = status ? '1em' : 0;
    gsap.to(animationTarget, {
      height: height,
      paddingBottom: padding,
      duration: 0.25,
    });
  };

  const toggleLabelAnimation = function (e, status) {
    const target = e.target;
    const wrapper = e.currentTarget;

    let animationTarget =
      wrapper.querySelector('input') || wrapper.querySelector('textarea');
    if (!animationTarget) return;

    if (
      target.tagName.toUpperCase() != 'INPUT' &&
      target.tagName.toUpperCase() != 'TEXTAREA' &&
      !target.closest('.choices')
    )
      return;

    if (!$(target).val().trim()) {
      $(wrapper).attr('data-input-animated-label', status);

      if (animationTarget.tagName.toUpperCase() === 'INPUT') {
        activateInput(animationTarget, status);
      } else if (animationTarget.tagName.toUpperCase() === 'TEXTAREA') {
        const exiting = e.type === 'focusout';

        const { input, newHeight } = getTextareaHeight($(target), exiting);
        activateTextarea(input, newHeight);
      }
    }
  };

  const getTextareaHeight = function ($context, exiting) {
    const $wrapper = $context.parents(selectors.animatedLabelsWrapper);
    if (!$wrapper.length) return;

    const $textareaProxy = $wrapper.find(selectors.textareaProxy);
    if (!$textareaProxy) return;

    const $input = $wrapper.find('textarea');
    if (!$input) return;

    $textareaProxy.html($input.val());

    const input = $input.get(0);
    const textareaProxy = $textareaProxy.get(0);

    // Add a char to init first row height calculations if there is no text in proxy
    if (textareaProxy.textContent.trim() == '' && !exiting) {
      textareaProxy.textContent = 'placeholder';
    }

    const newHeight = textareaProxy.offsetHeight;

    return {
      input,
      newHeight,
    };
  };

  const activateTextarea = function (animationTarget, newHeight) {
    gsap.to(animationTarget, {
      height: newHeight,
      duration: 0.25,
    });
  };

  const resetTextArea = function (wrapper) {
    const textarea = wrapper.querySelector('textarea');
    if (!textarea) return;

    const textareaProxy = wrapper.querySelector(selectors.textareaProxy);
    if (textareaProxy && textarea.value == '') {
      textareaProxy.textContent = '';
    }
  };

  const toggleDisabledUI = function (context) {
    const disabledInputs = context.querySelectorAll('[disabled]');

    if (disabledInputs && disabledInputs.length) {
      const inputsList = Array.from(disabledInputs);
      inputsList.map((input) => {
        const wrapper = input.closest(selectors.animatedLabelsWrapper);
        if (wrapper) {
          wrapper.setAttribute('data-input-disabled', true);
        }
      });
    }
  };

  // Adding animation
  $(rootEl ?? 'form').on(
    'focus',
    selectors.animatedLabelsWrapper,
    function (e) {
      toggleLabelAnimation(e, true);
    },
  );

  $(rootEl ?? 'form').on(
    'click',
    selectors.animatedLabelsWrapper,
    function (e) {
      if (e?.target?.dataset?.inputAnimatedLabel !== true) {
        const label = e.target.querySelector('label');
        if (label) label.click();
      }
    },
  );

  //Removing animation
  $(rootEl ?? 'form').on('blur', selectors.animatedLabelsWrapper, function (e) {
    const wrapper = $(e.target).parents(selectors.animatedLabelsWrapper).get(0);
    resetTextArea(wrapper);
    toggleLabelAnimation(e, false);
  });

  // Autoscale textarea
  if (rootEl) {
    $(rootEl)
      .find('textarea')
      .on('input', function () {
        const { input, newHeight } = getTextareaHeight($(this));
        activateTextarea(input, newHeight);
      });
  } else {
    $('textarea').on('input', function () {
      const { input, newHeight } = getTextareaHeight($(this));
      activateTextarea(input, newHeight);
    });
  }

  $(document).ready(function () {
    toggleDisabledUI(document);
  });

  const toggleSelectAnimation = function (e, status) {
    const target = e.target;
    if (!target) return;

    const wrapper = target.closest(selectors.animatedLabelsWrapper);
    if (!wrapper) return;

    wrapper.setAttribute('data-input-animated-label', status);
  };

  var fancySelectsNodes = document.querySelectorAll(selectors.fancySelects);
  if (rootEl)
    fancySelectsNodes = rootEl.querySelectorAll(selectors.fancySelects);
  if (fancySelectsNodes.length) {
    const selects = Array.from(fancySelectsNodes);
    selects.map((selectWrapper) => {
      const select = selectWrapper.querySelector('select');
      if (select) {
        new Choices(select, {
          shouldSort: false,
          searchEnabled: false,
          itemSelectText: '',
        });

        const label = selectWrapper.querySelector('label');
        const choices = selectWrapper.querySelector('.choices');
        if (label && choices)
          label.addEventListener('click', () => {
            if (!choices.classList.contains('is-open')) choices.click();
          });

        selectWrapper.addEventListener(
          'showDropdown',
          function (e) {
            toggleSelectAnimation(e, true);
          },
          false,
        );

        selectWrapper.addEventListener(
          'hideDropdown',
          function (e) {
            if (!selectWrapper.classList.contains('first-choice--happened')) {
              toggleSelectAnimation(e, false);
            }
          },
          false,
        );

        selectWrapper.addEventListener(
          'choice',
          function (e) {
            selectWrapper.classList.add('first-choice--happened');
          },
          false,
        );
      }
    });
  }

  var passwordInputs = document.querySelectorAll(selectors.passwordInput);
  if (rootEl) passwordInputs = rootEl.querySelectorAll(selectors.fancySelects);
  if (passwordInputs.length) {
    const pwInputs = Array.from(passwordInputs);
    pwInputs.map((wrapper) => {
      wrapper.addEventListener('click', (e) => {
        if (e.target.closest(selectors.iconClass)) {
          let visibilityAttributeValue = '';
          let inputType = 'password';
          const input = wrapper.querySelector('input');
          const isVisible = input.getAttribute('type') !== 'password';

          if (!isVisible) {
            visibilityAttributeValue = 'visible';
            inputType = 'text';
          }
          input.setAttribute('type', inputType);
          wrapper.setAttribute(attributes.password, visibilityAttributeValue);
        }
      });
    });
  }
};
(function ($) {
  window.dAgency.initInputs();
})(jQuery);
